import {
  signOut,
  signInWithPopup,
  GoogleAuthProvider,
  OAuthProvider,
} from "firebase/auth";
import { doc, getDoc, setDoc } from "firebase/firestore";

async function createIfMissing(collection, item, data) {
  try {
    const userDocRef = doc(window.db, collection, item);
    const userDocSnapshot = await getDoc(userDocRef);

    if (!userDocSnapshot.exists()) {
      await setDoc(userDocRef, data);
    }
  } catch (error) {
    console.error("Error creating " + collection + " document: ", error);
  }
}

// Function to create user document
async function createRolesDocument(user) {
  // Don't bother. I made this secure on the backend.
  createIfMissing("userRoles", user.email, {
    roles: [],
    userId: user.uid,
  });
}

function clickSignOut(auth, router) {
  signOut(auth).then(() => {
    router.push("/");
  });
}

async function signInWithGoogle(auth) {
  const provider = new GoogleAuthProvider();
  try {
    const result = await signInWithPopup(auth, provider);
    createRolesDocument(result.user);
    console.log("Sign in Complete.", result.user);
    return result;
  } catch (error) {
    // Handle specific cross-origin errors
    if (error.message && error.message.includes("cross-origin")) {
      console.warn(
        "Cross-origin error during OAuth, this is usually harmless:",
        error,
      );
      // The authentication might still have succeeded, so don't throw
      return null;
    }
    // Re-throw other errors
    throw error;
  }
}
function signInWithMicrosoft(auth) {
  const provider = new OAuthProvider("microsoft.com");

  signInWithPopup(auth, provider)
    .then((result) => {
      createRolesDocument(result.user);
      console.log("Sign in Complete.", result.user);
    })
    .catch((error) => {
      console.log(error);
    });
}

export {
  createRolesDocument,
  clickSignOut,
  signInWithGoogle,
  signInWithMicrosoft,
};
